
import Vue from 'vue'
import axios from 'axios'

import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@/assets/index.css'
import './filter/filter.js'
import './permissions.js'
import VuejsClipper from 'vuejs-clipper/dist/vuejs-clipper.umd'
import VueRx from 'vue-rx'
Vue.http = Vue.prototype.$http = axios

const vuetifyOptions = {}

Vue.use(VueRx)

Vue.config.productionTip = false

Vue.use(Vuetify, {})

Vue.use(VuejsClipper)

/* eslint-disable no-new */
new Vue({
  components: {App},
  router,
  store,
  template: '<App/>',
  vuetify: new Vuetify(vuetifyOptions)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js